module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "white-box recharge-succ"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "succ-tips"
  }, [_vm._v("提交成功，等待财务审核")]), _vm._v(" "), _c('p', {
    staticClass: "succ-sub-tips"
  }, [_vm._v("审核完成后，会通过短信通知您，短信将发到您登陆本系统的手机号")]), _vm._v(" "), _c('p', {
    staticClass: "succ-sub-tips"
  }, [_vm._v("您还可以，点此"), _c('span', {
    on: {
      "click": function($event) {
        _vm.go('rechargelist')
      }
    }
  }, [_vm._v("查看充值申请")]), _vm._v(" 或 "), _c('span', {
    on: {
      "click": function($event) {
        _vm.go('recharge')
      }
    }
  }, [_vm._v("继续发起充值申请")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "succ-icon"
  }, [_c('i', {
    staticClass: "el-icon-circle-check"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-733d2f5e","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/advancePayment/rechargeSuccess.vue
// module id = 945
// module chunks = 1